export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full max-w-md lg:max-w-sm">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20entertainment%20news%20app%20interface%20with%20dark%20theme%20and%20red%20accents%2C%20gossip%20news%20feed%20design%2C%20clean%20minimal%20UI%20with%20card%20layout%2C%20mobile%20app%20screenshot%20style%2C%20professional%20product%20presentation%2C%20sleek%20modern%20design&width=600&height=800&seq=app-mobile-mock&orientation=portrait"
                alt="91黑料网移动端界面预览"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              移动端入口
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg lg:max-w-none leading-relaxed">
              91黑料网已全面适配移动端设备，用户可通过手机浏览器直接访问，随时随地追最新黑料吃瓜爆料。
              移动端页面加载速度更快，浏览体验更流畅，让吃瓜不受时间和地点限制。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white font-label font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer text-center"
              >
                <i className="ri-smartphone-line mr-2"></i>手机端访问
              </a>
              <a
                href="#hero"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-background-300 text-foreground-700 font-label font-semibold text-sm whitespace-nowrap hover:bg-background-200 transition-colors cursor-pointer text-center"
              >
                <i className="ri-qr-code-line mr-2"></i>扫码直达
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}